module.exports = __webpack_public_path__ + "static/media/Untitled-3@3x.3fc4689d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/02/02/assets/Untitled-3@3x.svg
// module id = 437
// module chunks = 0